import { render, staticRenderFns } from "./MyDeliveryOrder.vue?vue&type=template&id=2a25089e&"
import script from "./MyDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./MyDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./MyDeliveryOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports